export default {
  frame: {
    sysInform: '系统消息',
    loadingMore: '加载更多...',
    doc: '详细文档',
    warning: '服务器繁忙，请稍后再试 ...',
    top: '置顶',
    expiryDate: '有效周期',
    to: '至',
    relatedFiles: '相关附件',
    home: '首页',
    list: '消息列表',
    title: '消息列表',
    listDetail: '消息详情',
    systemInfo: '系统消息',
    systemInfoContent: '您的token已失效，请尝试重新登录！',
    pagerFooter: '中国移动国际有限公司 版权所有',
    changeTitle: '修改密码',
    mySettings: '我的设置',

    firstName: '名',
    lastName: '姓',
    alias: '别名',
    email: '电子邮箱',
    staffNO: '登录工号',
    nickname: '昵称',
    phone: '电话',
    mobile: '手机',
    fax: '传真',
    department: '部门',
    countryRegion: '国家/地区',
    stateProvince: '州/省',
    city: '城市',
    postCode: '邮政编码',
    streetAddress: '街道地址',
    currency: '币种',
    cancel: '取消',

    HKD: '港币 HKD',
    USD: '美元 USD',
    EUR: '欧元 EUR',
    SGD: '新加坡元 SGD',
    GBP: '英镑 GBP',
    CNY: '中国人民币 CNY',

    personalTitle: '个人信息',
    accountId: '用户ID',
    oldPsd: '旧密码',
    newPsd: '新密码',
    confirmNew: '确认新密码',
    mobileNum: '手机号码',
    psdRule: '密码规则',
    rule1: '8位或以上长度',
    rule2: '包含来自以下四类中的三类:',
    rule3: '大写英文字母（从 A 到 Z）',
    rule4: '小写英文字母（从 a 到 z）',
    rule5: '10 个基本数字（从 0 到 9）',
    rule6: '密码有效时间为90天',
    rule7: '不能与前五次使用密码重复',
    rule8: '特殊字符（！@#￥%^&*）',
    submit: '提交',
    check: '新密码与确认密码不一致',
    inputNull: '不能为空',
    btn_yes: '确定',
    change_psd: '修改密码',
    emailError: '格式错误',
    mobileError: '请按格式输入：(+国家代码)电话号码，如(+86)13112345678',
  },
  promotion: {
    cancel: '取消',
    ok: '确定'
  },
  message: {
    modify_success: '修改成功',
    modify_fail: '修改失败',
    save_success: '保存成功',
    save_fail: '保存失败',
    del_success: '删除成功',
    del_partner_sure: '您确定要删除此合作伙伴吗？',
    del_chl_sure: '您确定要删除此渠道信息吗？'
  },
  notice_local: {
    notice: {
      create_success: '新增公告成功',
      create_erromessge: '新增公告失败',
      update_success: '修改公告成功',
      update_erromessge: '修改公告失败',
      logout_success: '注销操作成功',
      logout_fail: '注销操作不成功',
      verify_time: '生效时间必须小于失效时间',
      logout_erromessge: '无法进行注销操作',
      one_select: '只能操作一条数据',
      logout_erromessge_select: '请选择操作信息',
      update_erromessge: '无法进行修改操作',
      qry_erromessge: '查询操作失败',
      title: 'home',
      sub_title: '系统管理',
      main_title: '公告管理',
      query_title: '公告标题',
      query_state: '公告状态',
      query_effective: '生效时间',
      query_expiry: '失效时间',
      query_btn: '查询',
      query_new: '新增',
      logout_btn: '注销',
      tab_id: '公告ID',
      tab_title: '公告标题',
      tab_level: '公告级别',
      tab_range: '发布级别',
      tab_state: '显示状态',
      tab_effective: '生效时间',
      tab_expiry: '失效时间',
      tab_creat: '创建时间',
      tab_operation: '操作',
      tab_modify: '修改',
      tab_detail: '详情',
      tab_delete: '删除',
      pop_modify_title: '公告标题',
      pop_notice_state: '显示状态',
      pop_notice_content: '公告内容',
      pop_notice_stick: '是否置顶',
      pop_notice_unit: '发布单位',
      pop_notice_role: '发布角色',
      pop_submit: '提交',
      list_title: '公告列表',
      list_tag_top: '置顶',
      list_tag_emergency: '紧急',
      list_tag_important: '重要'
    }
  },
  my_task: {
    myTasks: '我的任务',
    dueDate: '到期日期',
    status: '状态',
    subject: '主题',
    name: '名称',
    relatedTo: '相关项',
    account: '客户',
    oper: '操作',
    newTask: '新增',
    complete: '完成',
    modify: '修改',
    detail: '详情',
    taskListFilter: '任务列表筛选器:',
    taskDetail: '任务详情',
    newTaskAdd: {
      newTasks: '新增任务',
      recordType: '记录类型',
      subject: '主题',
      assignedTo: '被分配人',
      name: '名称',
      activityCurrency: '活动币种',
      comments: '留言',
      priority: '优先级',
      createRecurrTasks: '创建重复任务',
      attachments: '附件',
      upload: '上传',
      submit: '提交',
      select: '选择',
      dueDate: '到期日期',
      relatedTo: '相关项',
      submitSuccess: '提交成功!',
      status: '状态',
      cancel: '取消',
      notEmpty: '不能为空',
      modifyTask: '修改任务',
      modifySeris: '修改序列',
      cancelReturn: '返回'
    },
    staff: {
      staffInfo: '选择被分配人',
      staffNo: '员工编号',
      staffName: '员工姓名',
      departName: '部门名称',
      contactTel: '联系电话',
      search: '查询'
    },
    contact: {
      contactInfo: '选择联系人',
      contactType: '联系人类别',
      contactName: '联系人名称',
      contactEmail: '邮箱',
      contactTel: '电话号码',
      contactTitle: '职位',
      contactCountry: '国家/地区'
    },
    campaign: {
      campaignInfo: '选择市场活动',
      campaignName: '市场活动名称',
      startDate: '开始日期',
      status: '状态',
      updatedTime: '更新时间'
    },
    opportunity: {
      opportunityInfo: '选择商机',
      opportunity_name: '商机名称',
      customer_name: '客户名称',
      close_date: '结束日期',
      stage: '阶段',
      owner: '所有人',
      created_time: '创建时间'
    },
    leads: {
      leadsInfo: '选择潜在客户',
      leadSource: '潜在客户来源',
      leadCurrency: '潜在客户币种',
      company: '公司',
      owner: '潜在客户所有人',
      leadStatus: '潜在客户状态',
      creator: '创建人',
      creatorDate: '创建时间'
    },
    cust: {
      custInfo: '选择客户',
      customer_name: '客户名称',
      inter_account_manage: 'Internet客户经理',
      voice_account_manage: 'Voice客户经理',
      mobile_account_manage: 'Mobile客户经理',
    },
    subjectSelect: {
      selectSubjectInfo: '从下面选择 主题'
    }
  },
  handle_local: {
    handle: {
      order_title: '工单标题',
      applicant: '申请工号',
      applicant_name:'申请人',
      application_date: '申请日期',
      query_btn: '查询',
      application_form_title: '工单标题',
      operation: '操作',
      unHandle: '待办',
      handle: '已办'
    }
  }

}



// WEBPACK FOOTER //
// ./src/locals/zh-CN.js